"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopAreaBannerSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _styles = require("../../styles");
var _constants2 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const TopAreaBannerSkeleton = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants2.TOP_AREA_BANNER_BENEFIT_BANNER_SKELETON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      animation: "pulse",
      height: _constants.TOP_AREA_BANNER_HEIGHT,
      variant: "rectangular",
      width: "100%"
    })
  });
};
exports.TopAreaBannerSkeleton = TopAreaBannerSkeleton;